<template>
 <div>
  <div v-if="localizationFromLegacy">
    <p v-html="localizationFromLegacy"></p>
  </div>
  <div v-else>
    <p v-html="streetAddress" />
    <p v-html="cityAddress" />
  </div>
</div>
</template>

<script>
  export default {
    name: 'FullAddress',
    props: {
      address: {
        type: Object,
        required: true,
      },
      localizationFromLegacy: {
        type: String,
        required: false,
      },
    },
    computed: {
      streetAddress() {
        return ` ${this.address.street || ''} ${this.address.streetNumber || ''} ${this.address.flatNumber ? `/${this.address.flatNumber}` : ''}`;
      },
      cityAddress() {
        return `${this.address.postcode || ''} ${this.address.city || ''}`;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/full_address.vue?460c36cb